export enum ActionTypes {
	DISMISS = "DISMISS",
	SNOOZE = "SNOOZE",
	SPAWN = "SPAWN",
	QUERY = "QUERY",
	PUBLISH = "PUBLISH",
	TRANSMIT = "TRANSMIT",
}

export enum FinsembleNotificationOptions {
	MARK_AS_UNREAD = "MARK_AS_UNREAD",
	MARK_AS_READ = "MARK_AS_READ",
	SNOOZE = "SNOOZE",
	DISMISS = "DISMISS",
	SETTINGS = "SETTINGS",
	DETAILS = "DETAILS",
}
